import React from "react";
import "./billOfSupply.css";
const numWords = require('num-words')

export default function BillOfSupply() {

  const bos_data = JSON.parse(localStorage.getItem('bos_data'));
  if (bos_data==undefined)
    return;
  const amountInINR = numWords((bos_data.amount+"").split(".")[0]).toUpperCase();
  const amountInPaisa = numWords((bos_data.amount+"").split(".")[1]).toUpperCase();
  const amountInWords = (amountInINR+" INR and "+amountInPaisa+" PAISE ONLY")

  return (
    <section className="bos">
      <h1>Bill Of Supply</h1>
      <div className="bos_header">
        <div className="bos_header_left">
          <div className="bos_header_left_1">
            <p className="bos_bold">BHAGWATI TRADING</p>
            <p>
              VISHAL HOTEL
              <br />
              STATION ROAD DEHRI ON SONE
              <br />
              ROHTAS
              <br />
              GSTIN/UIN: 10AIGPA0797E1ZV
              <br />
              State Name : Bihar, Code : 10
              <br />
              E-Mail : bhagwatitradingdehri@gmail.com
            </p>
          </div>
          <div className="bos_header_left_2">
            Consignee (Ship to)
            <p className="bos_bold">JHUNJHUNWALA OIL MILL LTD.</p>
            <p>
              VILL.-BAGRA ,POST-KUDRA,DIST-KAMOOR (BIHAR) <br /> GSTIN/UIN :
              10AABCJ3271C1ZC <br /> State Name : Bihar, Code : 10
            </p>
          </div>
          <div className="bos_header_left_3">
            Buyer (Bill to)
            <p className="bos_bold">JHUNJHUNWALA OIL MILL LTD.</p>
            <p>
              VILL.-BAGRA ,POST-KUDRA,DIST-KAMOOR (BIHAR) <br /> GSTIN/UIN :
              10AABCJ3271C1ZC <br /> State Name : Bihar, Code : 10
            </p>
          </div>
        </div>
        <div className="bos_header_right">
          <div className="bos_header_right_card">
            <p>Invoice No.</p>
            <p className="bos_bold">{bos_data.invoice}</p>
          </div>
          <div className="bos_header_right_card">
            <p>Dated</p>
            <p className="bos_bold">{bos_data.date}</p>
          </div>
          <div className="bos_header_right_card">
            <p>Delivery Note</p>
            <p className="bos_bold"></p>
          </div>
          <div className="bos_header_right_card">
            <p>Mode/Terms of Payment</p>
            <p className="bos_bold"></p>
          </div>
          <div className="bos_header_right_card">
            <p>Reference No. & Date.</p>
            <p className="bos_bold"></p>
          </div>
          <div className="bos_header_right_card">
            <p>Other References</p>
            <p className="bos_bold"></p>
          </div>
          <div className="bos_header_right_card">
            <p>Buyer's Order No.</p>
            <p className="bos_bold"></p>
          </div>
          <div className="bos_header_right_card">
            <p>Dated</p>
            <p className="bos_bold"></p>
          </div>
          <div className="bos_header_right_card">
            <p>Dispatch Doc No.</p>
            <p className="bos_bold">{bos_data.invoice}</p>
          </div>
          <div className="bos_header_right_card">
            <p>Delivery Note Date</p>
            <p className="bos_bold"></p>
          </div>
          <div className="bos_header_right_card">
            <p>Dispatched through</p>
            <p className="bos_bold">Truck</p>
          </div>
          <div className="bos_header_right_card">
            <p>Destination</p>
            <p className="bos_bold">{bos_data.destination}</p>
          </div>
          <div className="bos_header_right_card">
            <p>Bill of Lading/LR-RR No.</p>
            <p className="bos_bold"></p>
          </div>
          <div className="bos_header_right_card">
            <p>Motor Vehicle No.</p>
            <p className="bos_bold">{bos_data.veh}</p>
          </div>
          <div className="bos_header_right_terms">
            <p>Terms of Delivery</p>
          </div>
        </div>
      </div>
      <table className="bos_item_table">
        <thead>
          <tr>
            <td>Sl No.</td>
            <td>No. & Kind of Pkgs.</td>
            <td>Description of Goods</td>
            <td>HSN/SAC</td>
            <td>Quantity</td>
            <td>Rate</td>
            <td>per</td>
            <td>Amount</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>{bos_data.bags}</td>
            <td className="bos_bold bos_text_left">{bos_data.item}</td>
            <td>1006</td>
            <td className="bos_bold">{bos_data.quantity} QTL</td>
            <td>{bos_data.rate}</td>
            <td>QTL</td>
            <td className="bos_bold">{bos_data.amount}</td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td>Total</td>
            <td></td>
            <td className="bos_bold">{bos_data.quantity} QTL</td>
            <td></td>
            <td></td>
            <td className="bos_bold">{bos_data.amount} ₹</td>
          </tr>
        </tfoot>
      </table>
      <div className="bos_middle_amount_chargable">
        <div className="bos_amount_chargeable">
          <p>Amount Chargeable (in words)</p>
          <p>E. & O.E</p>
        </div>
        <p className="bos_bold">
          {amountInWords}
        </p>
      </div>
      <table className="bos_hsn_table">
        <thead>
          <tr>
            <td>HSN/SAC</td>
            <td>Taxable Value</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1006</td>
            <td>{bos_data.amount}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td className="bos_bold bos_text_right">Total</td>
            <td className="bos_bold">{bos_data.amount}</td>
          </tr>
        </tfoot>
      </table>
      <div className="bos_footer">
        <div className="bos_footer_left">
          <div className="bos_footer_left_top">
            <p>
              Tax Amount (in words) : <span className="bos_bold">NIL</span>
            </p>
          </div>
          <div className="bos_footer_left_bottom">
            <p>
              <span className="bos_text_italic bos_text_underline">
                Remarks:
              </span>
              <br /> {bos_data.narration} <br />{" "}
              Company's PAN : <span className="bos_bold">AIGPA0797E</span>
            </p>
            <p>
              <span className="bos_text_italic bos_text_underline">
                Declaration:
              </span>
              <br /> We declare that this invoice shows the actual price of the
              goods described and that all particulars are true and correct.
            </p>
          </div>
        </div>
        <div className="bos_footer_right">
          <p>
            Company's Bank Details <br /> A/c Holder's Name:{" "}&nbsp;
            <span className="bos_bold">BHAGWATI TRADING</span>
            <br /> Bank Name :{" "}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span className="bos_bold">I.C.I.C.I &nbsp;&nbsp;BANK</span>
            <br /> A/c No. :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span className="bos_bold">243905001879</span>
            <br /> Branch & IFS Code:{" "}
            <span className="bos_bold">&nbsp;DEHRI & ICIC0002439</span>
          </p>
          <div className="bos_footer_right_signature">
            <p>for BHAGWATI TRADING</p>
            <p>Authorised Signatory</p>
          </div>
        </div>
      </div>
      <div className="bos_footer_note">
        <p>SUBJECT TO SASARAM JURISDICTION</p>
        <p>This is a Computer Generated Invoice</p>
      </div>
    </section>
  );
}
